import React from 'react';
import {formatAcuities, formatRetinos} from "./mesures";
import {Mesures, Side, TypesMesures} from "../../../Shared/Enums/Enums";
import {t} from "../../../I18n/i18n";
import MesureStore from "../MesureStore";
import {VANESSA_LABARBE_ID} from "../../../Shared/Helper";

function MesureOverview({mesure, type}) {

    if(!type) return null

    const renderTension = () => {
        return <div style={{display: "flex", flexDirection: "column"}}>
            {mesure.od_tension ?
                <h6 style={{margin: 0}}>OD : {mesure.od_tension < 0 ? "NM" : mesure.od_tension}</h6> : null}
            {mesure.og_tension ?
                <h6 style={{margin: 0}}>OG : {mesure.og_tension < 0 ? "NM" : mesure.og_tension}</h6> : null}
        </div>
    }

    const renderPachymetry = () => {
        return <div style={{display: "flex", flexDirection: "column"}}>
            {mesure.od_pachymetrie ? <h6 style={{margin: 0}}>OD : {mesure.od_pachymetrie} µm</h6> : null}
            {mesure.og_pachymetrie ? <h6 style={{margin: 0}}>OG : {mesure.og_pachymetrie} µm</h6> : null}
        </div>
    }

    const renderMeasure = () => {
        const has_bino = type.bino || type.only_bino
        const has_bino_only = type.only_bino

        const lateralized = <>
            <h6 style={{margin: 0, fontSize: 10}}>
                OD : {formatRetinos(mesure, Side.RIGHT)}
                {formatAcuities(mesure, Side.RIGHT, true)}
                {mesure.od_data_text ? <span style={{fontSize: 10}}> {mesure.od_data_text}</span> : null}
            </h6>
            <h6 style={{margin: 0, fontSize: 10}}>
                OG : {formatRetinos(mesure, Side.LEFT)}
                {formatAcuities(mesure, Side.LEFT, true)}
                {mesure.og_data_text ? <span style={{fontSize: 10}}> {mesure.og_data_text}</span> : null}
            </h6>
        </>

        const bino = <>
            <h6 style={{margin: 0, fontSize: 10}}>
                Bino : {formatRetinos(mesure, Side.BINO)}
                {formatAcuities(mesure, Side.BINO, true)}
                {mesure.bino_data_text ? <span style={{fontSize: 10}}> {mesure.bino_data_text}</span> : null}
            </h6>
        </>

        return <div style={{display: "flex", flexDirection: "column"}}>
            {has_bino_only ? null : lateralized}
            {has_bino ? bino : null}
        </div>
    }

    const renderKerato = () => {
        //we display a new kerato display for LABARBE in a first time. If ok we will generalize that for all orthoptistes
        if(MesureStore.orthoptiste.id === VANESSA_LABARBE_ID){
            return <div style={{display: "flex", flexDirection: "column"}}>
                {mesure.od_radius_1 && mesure.od_radius_2 && mesure.od_degree ? <h6 style={{margin: 0, fontSize: 10}}>OD :
                    K1 {mesure.od_radius_1} K2 {mesure.od_radius_2} {t("ACTIVE_TABS.AXIS")} {mesure.od_degree}°</h6> : null}
                {mesure.og_radius_1 && mesure.og_radius_2 && mesure.og_degree ? <h6 style={{margin: 0, fontSize: 10}}>OG :
                    K1 {mesure.og_radius_1} K2 {mesure.og_radius_2} {t("ACTIVE_TABS.AXIS")} {mesure.og_degree}°</h6> : null}
            </div>
        } else {
            return <div style={{display: "flex", flexDirection: "column"}}>
                {mesure.od_radius_1 && mesure.od_radius_2 && mesure.od_degree ? <h6 style={{margin: 0, fontSize: 10}}>OD :
                    R1 {mesure.od_radius_1} R2 {mesure.od_radius_2} D {mesure.od_degree}°</h6> : null}
                {mesure.og_radius_1 && mesure.og_radius_2 && mesure.og_degree ? <h6 style={{margin: 0, fontSize: 10}}>OG :
                    R1 {mesure.og_radius_1} R2 {mesure.og_radius_2} D {mesure.og_degree}°</h6> : null}
            </div>
        }
    }

    switch (type.name) {
        case Mesures.TENSION.value :
            return renderTension();
        case Mesures.PACHYMETRY.value :
            return renderPachymetry();
        case Mesures.KERATOMETRY.value :
            return renderKerato();
        default :
            return renderMeasure();
    }

}

export default MesureOverview;